import { ComposedChart, ResponsiveContainer } from "recharts";

export default function Chart({ width, height, data, children, className }) {
  return (
    <ResponsiveContainer width={width} height={height} className={className}>
      <ComposedChart data={data}>{children}</ComposedChart>
    </ResponsiveContainer>
  );
}
